<template>
  <v-app class="pa-3">
    <v-overlay
      :opacity="1"
      :value="overlay"
      color="#fff"
    >
      <v-progress-circular
        indeterminate
        size="130"
        :width="2"
        color="pink darken-1"
      >
        <v-img
          v-if="$brand === 'abriron'"
          width="120"
          src="https://abriron.com/wp-content/uploads/2020/12/ironlogo.png"
        />
        <v-img
          v-if="$brand !== 'abriron'"
          width="60"
          class="pt-3 px-2"
          :src="logoBrand"
        />
      </v-progress-circular>
    </v-overlay>
    <v-main>
      <v-form ref="form">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              md="6"
            />
            <div>
              dasd
            </div>
            <v-list
              subheader
              two-line
              flat
              dense
            >
              <v-list-item-group
                v-for="(item, i) in items"
                :key="i"
                multiple
                v-model="list"
              >
                <v-subheader>{{item.name}}</v-subheader>
                <v-list-item
                  v-for="(servic, j) in item.items"
                  :key="j"
                >
                  <template v-slot:default="{ active, }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{servic.name}}</v-list-item-title>
                      <v-list-item-subtitle>Allow notifications</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <v-col />
          </v-row>
        </v-container>
      </v-form>
    </v-main>
    <v-footer
      class="py-2"
      style="font-size: 12px;"
      padless
    >
      <v-col
        class="text-center py-1"
        cols="12"
      >
        {{ new Date().getFullYear() }} — Abriron Cloud Panel V {{ env.version }}
      </v-col>
    </v-footer>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-app>
</template>

<script>
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  export default {
    components: {
      Snakbar,
    },
    mixins: [General],
    data () {
      return {
        lang: {
          id: 1,
          title: 'فارسی',
          lang: 'fa',
          rtl: true,
          flagSrc: 'https://www.countryflags.com/wp-content/uploads/iran-flag-png-large.png',
        },
        items: [],
        list: null,
        shopId: null,
        email: null,
        overlay: false,
        phonePrefix: null,
        phone: null,
        checkCode: null,
        country: 'IRN',
        code: null,
        has_error: false,
        text_error: null,
        academy: null,
        loading: false,
      }
    },
    watch: {
      list (val) {
      },
    },
    beforeMount () {
      // this.getCountry()
      this.country = 'IRN'
      if (this.$route.query.app_key) {
        this.appKey = this.$route.query.app_key
      } else {
        this.appKey = localStorage.getItem('APP_KEY')
      }
      if (this.$route.query.ac_) {
        this.academy = true
      }
    },
    mounted () {
      this.getAbrPricing()
    },
    methods: {
      getAbrPricing () {
        var app = this
        if (app.abrkey) {
          app.$axios.defaults.headers.common.abr_key = app.appKey
        }
        app.$axios.defaults.headers.common.abr_key = app.appKey
        app.$axios.get(app.$apipoint + 'getcurrency?select=getAbrPrice&abrkey=' + app.appKey)
          .then(res => {
            res = res.data
            app.items = res
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },

  }
</script>

<style scoped>
div.vue-tel-input-vuetify > .v-input {
  margin-inline-end: 8px !important;
}
</style>
